var _a;
import { init, addMessages } from 'svelte-i18n';
import * as config from './config';
import en from './locales/en.json';
import de from './locales/de.json';
addMessages('en', en);
addMessages('de', de);
(_a = init({ fallbackLocale: config.FALLBACK_LOCALE, initialLocale: config.LOCALE })) === null || _a === void 0 ? void 0 : _a.then(console.log).catch(console.error);
